import { inject, observer } from 'mobx-react';
import { Regenerate, Copy, FeedBack } from '../OperateButton';
import { contentType } from '@/utils/Page/constant';
import { Display } from '@/components/Display/Display';
const noFooterTypes = [contentType.multimodal_learning, contentType.multimodal];

// todo---此页面需要补充deerflow的逻辑

const MessageFooter = (props) => {
    const { item, side, inInanswer, len, index, deerFlowHook, store, reGenerate, isInVoiceCall, hideTTSActionsRef, feedBack, status, copy } = props;
    let { skillStore } = store;
    const { isNoFooterSkills } = skillStore;
    const { content_type, role, recommend_course_result, handler } = item;
    if (index === len - 1) {
        console.log(inInanswer, 'statusstatusstatus');
    }
    return (
        <>
            <Display show={role !== 'local' && !noFooterTypes.includes(content_type) && !isNoFooterSkills() && !noFooterTypes.includes(handler)}>
                <Display show={status === 'complete'}>
                    <div
                        data-side={side}
                        data-answer={index === len - 1 && inInanswer ? 'true' : 'false'} // 只对最新消息应用inInanswer
                        className={`ai-action-wrap ${index === len - 1 ? 'last-msg' : 'previous-msg'}`}
                    >
                        {/* <Display show={side === 'mobile' ? (index === messages.length - 1 ? true : false) : true}> */}
                        <></>
                        <Display show={!recommend_course_result}>
                            <Copy
                                side={side}
                                className={`ai-copy-icon ${index !== len - 1 ? 'disabled' : ''}`}
                                onClick={(e) => {
                                    copy(item);
                                }}
                            ></Copy>

                            <Display show={skillStore?.skillAvailable}>
                                <Regenerate
                                    side={side}
                                    className={`ai-generate-icon ${index !== len - 1 ? 'disabled' : ''}`}
                                    onClick={() => {
                                        reGenerate(item);
                                    }}
                                    style={{
                                        display: item?.plugin_json?.voice_call && !isInVoiceCall ? 'none' : 'inline-block'
                                    }}
                                ></Regenerate>
                            </Display>
                        </Display>
                        <Display show={!recommend_course_result}>
                            <FeedBack
                                side={side}
                                className="ai-feed-back-icon"
                                onClick={() => {
                                    feedBack(item);
                                }}
                            ></FeedBack>
                        </Display>
                    </div>
                </Display>
            </Display>
        </>
    );
};
export default inject('store')(observer(MessageFooter));
